export default __webpack_public_path__ + "static/park-pedregal-amenidades-01-carril-nado-89bb81fc6ab67d41e7a02cf37d613a4f.jpg";